export default "__VITE_ASSET__dEs3HTMx__"